import React, { Component } from 'react';
import {Link} from "react-router-dom"
import moment from 'moment'
import './newsBox.css'
import { Uploader, UploadField } from '@navjobs/upload'
import {serverUrl} from '../../utils/restUtils'
import sanitizeHtml from 'sanitize-html'
import ReactTooltip from 'react-tooltip'


class NewsBox extends Component {

    render() {
	const {news, editAction, deleteAction, isMainAction, loadEvents, authenticated} = this.props


	return (
	    <div className={['news', 'col-12', 'col-sm-6', 'col-md-4', (authenticated ? 'admin_mode' : '')].join(' ')}>
		<ReactTooltip />
		{loadEvents && authenticated ?
		 <Uploader
		     request={{
			 fileName: 'file',
			 url: serverUrl()+'/events/'+news.id+'/image_upload',
			 method: 'PUT',
			 withCredentials: true
		     }}
		     onComplete={({ response, status }) => {
			 loadEvents()
		     }}
		     uploadOnSelection={true}
		 >
		     {({ onFiles, progress, complete }) => (
			 <div>

			     <div className="adminSection">
				 {authenticated && isMainAction ? <button style={{float: 'left', color: (news.is_main ? 'green' : 'red')}} data-tip="Postavi na glavno stran" className="btn" onClick={isMainAction}><i className="fa fa-star"></i></button> : null}
				 {authenticated && editAction ? <button style={{float: 'left'}}  data-tip="Spremeni"  className="btn" onClick={editAction}><i className="fa fa-edit"></i></button> : null}
				 {authenticated && deleteAction ? <button style={{float: 'right'}} data-tip="Zbriši"  className="btn" onClick={deleteAction}><i className="fa fa-remove"></i></button> : null}
				 <div style={{float: 'left'}}  data-tip="Dodaj ali menjaj sliko">
				     <UploadField onFiles={files => {
					 if(Array.from(files).map(f => f.size>100*1024*1024 ).filter(x => x ).length === 0)
					     onFiles(files)
					 else
					     alert('preveč velik file, max 100MB')
				     } } uploadProps={{ accept: '.png,.jpg,.jpeg,.svg,.gif'}}>
					 <button className="btn">
					     <i className="fa fa-camera"></i>
					 </button>
				     </UploadField>
				 </div>
				 <div style={{clear: 'both'}}></div>
			     </div>
			     
			     
			     
			     {!complete && progress  ?
			      <div className="progressBar">
				  <div style={{width: progress+'%'}}></div>
			      </div>
			     : null}

			 </div>
		     )}
		 </Uploader>
		: null}
		<Link to={'/events/'+news.id}>
		    <div className="imageContainer">
			<img src={news.image_id ? serverUrl()+'/images/'+news.image_id : '/images/noimage.png'} alt={news.title} className="full-width" />
			<div className={['title', news.title_font, news.title_position].join(' ')}>
			    { news.category ?
			      <div>
				  <h5>{news.subtitle}</h5>
				  <h4>{news.title}</h4>
			      </div>
			      : ''}
			</div>
		    </div>

		    <h3>{(!news.category ? news.subtitle : news.location)} <br /> {(!news.category ? news.title : moment(news.event_on).format("D. MMMM YYYY ob HH.mm"))}</h3>
		    <div className="description">{sanitizeHtml(news.description.substring(0, 250), {allowedTags:[]})} {news.description.length > 250 ? '...' : ''}</div>
		</Link>
		

	    </div>
	);
    }
}

export default NewsBox;



// WEBPACK FOOTER //
// ./src/components/NewsBox/index.jsx